import { render, staticRenderFns } from "./EfsMarginLedgerList.vue?vue&type=template&id=4672eee7&scoped=true&"
import script from "./EfsMarginLedgerList.vue?vue&type=script&lang=js&"
export * from "./EfsMarginLedgerList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMarginLedgerList.vue?vue&type=style&index=0&id=4672eee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672eee7",
  null
  
)

export default component.exports